import {
  Paper,
  Grid,
  Box,
  Menu,
  MenuItem,
  Badge,
  CircularProgress,
} from "@mui/material";
import { IconBtnBase, DataGrid, ResourcesList, DatePicker } from "Components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { http } from "Utils/Http/Http";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { PARTICIPATIONLIST } from "Constants/QueriesKeys";
import { useHistory } from "react-router-dom";
import dayjs from "dayjs";

const styles = {
  tableSize: {
    height: 650,
    width: "100%",
  },
};

const FeedbacksPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [feedbacksList, setFeedbacksList] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [track, setTrack] = useState("");

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState();
  const spacing = 4;
  const [paginator1, setPaginator1] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [version, setVersion] = useState(3);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleClose = () => setAnchorEl(null);

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const feedbacksListRender = useQuery(
    [PARTICIPATIONLIST, { page, startDate, endDate }],
    () => {
      let params = {
        page: page,
        limit: perPage,
      };
      if (startDate && endDate) {
        params.start_date = startDate;
        params.end_date = endDate;
      } else {
        delete params.start_date;
        delete params.end_date;
      }
      return http
        .get(`api/v1/admin/feedbacks`, {
          params: {
            page: page,
            limit: perPage,
            ...params,
          },
        })
        .then((response) => {
          return (
            (response,
            setFeedbacksList(response.data.data),
            setPaginator1(response?.data?.meta?.total)),
            setPerPage(response?.data?.meta?.per_page)
          );
        });
    }
  );

  const handleDownload = () => {
    setIsExporting(true);
    const link = document.createElement("a");
    link.target = "_blank";
    link.download = "feedbacks.xlsx";
    let searchParams = "";
    if (startDate && endDate) {
      searchParams = `?start_date=${startDate}&end_date=${endDate}`;
    }
    http
      .get(
        `api/v1/admin/feedbacks/export${searchParams}`,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        link.href = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        link.click();
        setIsExporting(false);
        setTrack("");
      })
      .catch(() => {
        setIsExporting(false);
        setTrack("");
      });
  };

  function getFullName(params) {
    return `${params.getValue(params.id, "first_name") || ""}
     ${
       params.getValue(params.id, "last_name") === "NO DATA"
         ? ""
         : params.getValue(params.id, "last_name")
     }`;
  }

  const columns1 = [
    {
      field: "id",
      headerName: t("ID"),
      width: 100,
      editable: false,
    },
    {
      field: "comment",
      headerName: "Comment",
      width: 230,
      renderCell: (row) => row?.row?.comment ?? "---",
    },
    {
      field: "level",
      headerName: "Level",
      width: 230,
      renderCell: (row) => row?.row?.level?.description ?? "---",
    },
  ];

  return (
    <ResourcesList
      headerProps={{
        title: t("feedbacks"),
        EndSide: (
          <div className="flex">
            <IconBtnBase onClick={handleClickMenu} size="large">
              <CloudDownloadOutlinedIcon />
            </IconBtnBase>
            <Menu
              id="lock-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "lock-button",
                role: "listbox",
              }}
            >
              <MenuItem
                disabled={isExporting}
                className="flex items-center gap-2"
                onClick={handleDownload}
              >
                Download Feedbacks
                {isExporting && <CircularProgress size={20} />}
              </MenuItem>
            </Menu>
          </div>
        ),
      }}
      Section={
        <div className="mt-8">
          <div className="flex gap-2">
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={(newValue) => {
                if (
                  dayjs(newValue).isAfter(endDate) ||
                  dayjs(newValue).isSame(endDate)
                ) {
                  setEndDate(null);
                }
                setStartDate(
                  newValue ? dayjs(newValue).format("YYYY-MM-DD") : null
                );
              }}
            />
            <DatePicker
              label="End Date"
              value={endDate}
              onChange={(newValue) =>
                setEndDate(
                  newValue ? dayjs(newValue).format("YYYY-MM-DD") : null
                )
              }
              disabled={!startDate}
              minDate={dayjs(startDate).add(1, "day")}
            />
          </div>
          <Box className="mt-8" sx={styles.tableSize}>
            <Grid container spacing={spacing}>
              <Grid item xs={12}>
                <Paper>
                  <DataGrid
                    rowCount={paginator1}
                    pagination
                    paginationMode="server"
                    onPageChange={(newPage) => setPage(newPage + 1)}
                    loading={feedbacksListRender?.isLoading}
                    rows={feedbacksList}
                    columns={columns1}
                    pageSize={perPage}
                  />
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </div>
      }
    />
  );
};
export default FeedbacksPage;
